import { COLORS, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';

export const STOverallInfoContainer = styled(Row)`
  padding: 16px 24px;
  border-radius: 8px;
  background-color: ${COLORS.CLOUD};
`;

export const TotalRequestCard = styled(Row)`
  padding: 0;
  gap: 16px;
  width: 125px;
`;

export const RequestDetailsContainer = styled(Row)`
  gap: 40px;
  padding: 0;
`;

export const RequestDetailsCard = styled(Row)`
  gap: 8px;
  padding: 0;
`;

export const RequestDetailTitle = styled(Text)`
  min-width: 6ch;
  max-width: max-content;
`;
